import React, { FunctionComponent } from 'react'
import styles from './style.module.css'
import { Heading } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'
import { useCheckoutSizes } from '../../utils/responsive'
import { useHasZeroAprConsumerLendingPromotion, useIsAfterpayFinanceFeeEligible } from '../../state'

export const ConsumerLendingTagline: FunctionComponent = () => {
  const { t } = useTranslation()
  const { textSize } = useCheckoutSizes()
  const hasZeroAprPromotion = useHasZeroAprConsumerLendingPromotion()
  const isAFF = useIsAfterpayFinanceFeeEligible()

  return (
    <>
      <div className={styles.payInMoreTaglineHeading}>
        <Heading size={textSize}>
          {hasZeroAprPromotion || isAFF ? t('consumerLending:payInMoreWithoutInterestTagLine') : t('consumerLending:payInMoreTagline')}
        </Heading>
      </div>
    </>
  )
}
